<template lang="pug">
  //- Datos de pago de la factura
  ods-dialog(
    ref='dialogPaymentData',
    :title='(emitted?$t("invoice_detail.dialog_payment_data.title_emitted"):$t("invoice_detail.dialog_payment_data.title_received")) + " " + this.invoiceNumber',
    :visible.sync='showDialog',
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @open='handleOpenDialogPaymentData'
    @close='handleCloseDialogPaymentData',
    width='80%')
    ods-module
      ods-table(
        v-if='paymentsData.length > 0 ',
        :data='paymentsData',
        :default-sort='{ prop: "remasa", order: "ascending" }',
        style='width: 100%',
        highlight-current-row,
        size='mini',
        fit)
        ods-table-column(
          width='100',
          prop='remasa',
          :label='$t("invoice_detail.payment_table.remasa")',
          :show-overflow-tooltip='true',
          sortable='')
        ods-table-column(
          width='200',
          prop='situacion',
          :label='$t("invoice_detail.payment_table.situacion")',
          :show-overflow-tooltip='true',
          sortable='')
          template(slot-scope='scope')
            span.blue-text(
              style='cursor: pointer;',
              v-if='scope.row.situacion==="Compensación" && ((scope.row.datosPago && scope.row.datosPago.length > 0) || (scope.row.datosCobro && scope.row.datosCobro.length > 0))'
            )
              a(
                @click='goToDetail(scope.row.remasa)'
              )
                | {{ scope.row.situacion }}
            span(
              v-if='scope.row.situacion!=="Compensación" || ((!scope.row.datosPago || scope.row.datosPago.length === 0) && (!scope.row.datosCobro || scope.row.datosCobro.length === 0))'
            )
                | {{ scope.row.situacion }}
        ods-table-column(
          width='130',
          prop='fechaAcept',
          :label='$t("invoice_detail.payment_table.fechaAcept")',
          :show-overflow-tooltip='true',
          sortable='')
        ods-table-column(
          width='135',
          prop='fechaVenc',
          :label='$t("invoice_detail.payment_table.fechaVenc")',
          :show-overflow-tooltip='true',
          sortable='')
        ods-table-column(
          width='130',
          prop='fechaValor',
          :label='$t("invoice_detail.payment_table.fechaValor")',
          :show-overflow-tooltip='true',
          sortable='')
        ods-table-column(
          width='150',
          prop='importeDivisa',
          align='right',
          :label='$t("invoice_detail.payment_table.importeDivisa")',
          :show-overflow-tooltip='true',
          :formatter='formatterMoney',
          sortable='')
          template(slot-scope='scope')
            ods-tooltip(placement='top')
              template(slot='content')
                | {{ formatterTooltipMoney(scope.row, scope.column) }}
              div.text-overflow-tooltip
                | {{ formatterMoney(scope.row, scope.column) }}
        ods-table-column(
          width='200',
          prop='importeComDivi',
          align='right',
          :label='$t("invoice_detail.payment_table.importeComDivi")',
          :show-overflow-tooltip='true',
          :formatter='formatterMoney',
          sortable='')
          template(slot-scope='scope')
            ods-tooltip(placement='top')
              template(slot='content')
                | {{ formatterTooltipMoney(scope.row, scope.column) }}
              div.text-overflow-tooltip
                | {{ formatterMoney(scope.row, scope.column) }}
        ods-table-column(
          width='200',
          prop='viaPago',
          :label='$t("invoice_detail.payment_table.viaPago")',
          :show-overflow-tooltip='true',
          sortable='')
          template(slot-scope='scope')
            ods-tooltip(placement='top')
              template(slot='content')
                | {{ formatterTooltipPago(scope.row, scope.column) }}
              div.text-overflow-tooltip
                | {{ scope.row.viaPago }}
        ods-table-column(
          width='200',
          prop='banco',
          :label='$t("invoice_detail.payment_table.banco")',
          :show-overflow-tooltip='true',
          sortable='')
          template(slot-scope='scope')
            ods-tooltip(placement='top')
              template(slot='content')
                | {{ formatterTooltipBanco(scope.row, scope.column) }}
              div.text-overflow-tooltip
                | {{ scope.row.banco }}

      div.paymentcharge(v-if='hasDocCobro || hasDocPago')
        ods-row.info
          ods-col(:span='24')
            p {{ $t('invoice_detail.payment_table.detalleCompensacion') + ' ' + $t("invoice_detail.payment_table.remasa").toLowerCase() + ' ' + this.remesa }}
        ods-row.infodata
          ods-col(:span='3')
            p
          div(v-if='hasDocCobro')
            ods-col(:span='10')
              p {{ $t('invoice_detail.payment_table.detalleCompensacionCobro') }}
              ods-table(
                v-if='hasDocCobro && paymentsDataCobro.length > 0 ',
                :data='paymentsDataCobro',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  width='200',
                  prop='numeroDocumento',
                  :label='$t("invoice_detail.payment_table.numeroDocumento")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='importe',
                  width='150',
                  :label='$t("invoice_detail.payment_table.importe")',
                  :show-overflow-tooltip='true',
                  sortable='')
          div(v-if='hasDocPago')
            ods-col(:span='10')
              p {{ $t('invoice_detail.payment_table.detalleCompensacionPago') }}
              ods-table(
                v-if='hasDocPago && paymentsDataPago.length > 0 ',
                :data='paymentsDataPago',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                div
                ods-table-column(
                  width='200',
                  prop='numeroDocumento',
                  :label='$t("invoice_detail.payment_table.numeroDocumento")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  width='150',
                  prop='importe',
                  :label='$t("invoice_detail.payment_table.importe")',
                  :show-overflow-tooltip='true',
                  sortable='')
    span.dialog-footer(slot='footer')
      ods-button(
        type='primary',
        @click.native='handleCloseDialogPaymentData')
        | {{ $t('buttons.btnOk') }}
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Util from '@/components/shared/Utils'

export default {
  name: 'PaymentDataDialog',
  mixins: [Util],
  props: ['showDialog', 'emitted', 'paymentsData', 'invoiceNumber'],
  data () {
    return {
      paymentsDataCobro: [],
      paymentsDataPago: [],
      hasDocCobro: false,
      hasDocPago: false,
      remesa: null
    }
  },
  computed: {
    ...mapGetters(['urlIn'])
  },
  methods: {
    ...mapActions([
      'getInvoicePaymentData'
    ]),

    handleCloseDialogPaymentData () {
      this.$emit('setterShowPaymentDataDialog', false)
    },
    async handleOpenDialogPaymentData () {
    },
    formatterTooltipMoney (row, column) {
      return this.$n(row[column.property], 'table') + ' ' + row.moneda
    },
    formatterMoney (row, column) {
      if (row.monedaSimbol) {
        return this.$n(row[column.property], 'table') + ' ' + row.monedaSimbol
      } else {
        return this.$n(row[column.property], 'table') + ' ' + row.moneda
      }
    },
    formatterTooltipBanco (row, column) {
      return row.desBanco
    },
    formatterTooltipPago (row, column) {
      return row.desViaPago
    },

    goToDetail (remasa) {
      this.remesa = remasa
      let hasDocCobro = false
      let hasDocPago = false
      const paymentsDataCobro = []
      const paymentsDataPago = []
      this.paymentsData.forEach(function (e) {
        if (e.remasa === remasa && e.datosCobro && e.datosCobro.length > 0) {
          hasDocCobro = true
          e.datosCobro.forEach(function (f) {
            paymentsDataCobro.push(f)
          })
        }
        if (e.remasa === remasa && e.datosPago && e.datosPago.length > 0) {
          hasDocPago = true
          e.datosPago.forEach(function (f) {
            paymentsDataPago.push(f)
          })
        }
      })
      this.hasDocCobro = hasDocCobro
      this.hasDocPago = hasDocPago
      this.paymentsDataCobro = paymentsDataCobro
      this.paymentsDataPago = paymentsDataPago
      console.log('paymentsDataCobro: ', this.paymentsDataCobro)
      console.log('paymentsDataPago: ', this.paymentsDataPago)
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          if (errorSms && errorSms.indexOf('does not exist') > -1) {
            errorSms = 'No se puede consultar la información para este servicio'
          }
          break
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },
  async created () {
    console.log('paymentsData: ', this.paymentsData)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-dialog {
      .info {
        color: black;
        size: 16px;
        margin-top: 40px;
        font-size: 18px;
        text-align: left;
      }
      .infodata {
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 18px;
        text-align: left;
        p {
          margin-bottom: 10px;
        }
      }
      span.blue-text {
        color: var(--color-bg-interactive);
        text-decoration: underline;
      }
      .ods-module {
        border-bottom: 0px solid var(--color-border-hard-divisor) important;
      }
      ::v-deep.ods-table__body-wrapper {
        margin-bottom: 20px !important;
      }
}
</style>
